import { makeStyles } from "@material-ui/core/styles";
import theme from "./index";

export const useStyles = makeStyles({
  searchContainer: {
    display: "flex",
    paddingLeft: "1.5em",
    paddingRight: "1.5em",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  tagSelector: {
    justifyContent: "center",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      // justifyContent: "space-evenly",
      // alignContent: "space-evenly",
    },
  },
  searchBox: {
    maxWidth: "700px",
    padding: "0.3em",
    width: "-webkit-fill-available",
    justifyContent: "flex-end",
    display: "flex",
  },
  tag: {
    fontSize: "14px",
    fontWeight: "bold",
    margin: "0em 0.2em",
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.1)",
    },
  },
});
